import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgActivityPaid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 11L2 9.5L6.5 16L17 1",
		stroke: "currentColor",
		strokeWidth: 1.7,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgActivityPaid;
